<!--
 * @Description: 分组管理
 * @Author: xu wei
 * @Date: 2020-03-05 14:04:55
 * @LastEditTime: 2020-08-24 19:30:13
 * @LastEditors: gao shuai
 -->
 <template>
  <div class="home">
    <div class="gs_title">网关检测</div>
    <div class="tablebox pdb15 pdt20">
      <div class="gs_tablebox">
        <el-table ref="moduleTable" size="mini" :data="tableData" border style="width: 100%" stripe>
          <el-table-column prop="id" label="编号">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="partitionName" label="分区名称">
          </el-table-column>
          <el-table-column prop="ipAddress" label="IP地址">
          </el-table-column>
          <el-table-column prop="port" label="端口">
          </el-table-column>
          <el-table-column prop="lastHeartbeatTime" label="上次在线时间">
          </el-table-column>
          <el-table-column prop="isOnline" label="是否在线">
             <template slot-scope="scope">
    <el-tag :type="scope.row.isOnline ? 'success' : 'danger'" effect="dark">
      {{ scope.row.isOnline ? '在线' : '离线' }}
    </el-tag>
  </template>
          </el-table-column>
           <el-table-column label="操作" width="350">
            <template slot-scope="scope">
              <el-button-group>
                <el-button size="mini" type="primary" @click="editClientInfo(scope.row.id,scope.row.ipAddress,scope.row.port)">编辑</el-button>
                <el-button size="mini" type="danger" @click.prevent="handleClose(scope.row.id)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mgt15 pdl20">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :page-sizes="[10, 20, 30, 40]" :current-page="pageIndex" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
     <el-dialog :title="'编辑网关'" :visible.sync="dialog.show" @close="dialoginit" custom-class="gs_dialog" width="400px">
      <div class="opeartbox">
        <ul class="clearfix">
          <li>
            <span class='tit' style="color:black">网关IP地址：</span>
            <span class="txtbox">
              <el-input size="small" v-model="dialog.ipAddress"></el-input>
            </span>
          </li>
          <li>
            <span class='tit' style="color: black;">端口:</span>
            <span class="txtbox">
              <el-input size="small" v-model="dialog.port"></el-input>
            </span>
          </li>
        </ul>
      </div>
      <p class="tc pdt10 pdb10">
        <el-button size="small" type="primary" @click="editsure">确定</el-button>
        <el-button size="small" type="info" @click="dialog.show =false">取消</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false, // 推广下载loading
      loadingIndex: '', // 推广下载index
      groupName: '', // 分组名称
      pageIndex: 1, // 页码
      pageSize: 20, // 每页的条数
      total: 0, // 总数据的条数
      tableData: [],
      refreshTimer: null,  // 定时器引用
      lastRefreshTime: null,  // 上次刷新时间
      dialog: {
        show: false,
        editflag: true,
        id: '',
        ipAddress: '',
        port:0,
      }
    };
  },
  methods: {
    // 获取列表
    getlist() {
      this.$api.clientinfo
        .clientInfoList({
          PageNumber: this.pageIndex,
          PageSize: this.pageSize
        })
        .then((data) => {
          if (data.status === 204) {
            this.tableData = [];
            this.total = 0;
          } else if (data.status === 200) {
            this.tableData = data.data;
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
// 编辑分组
    editClientInfo(id, ipAddress,port) {
      this.dialog.ipAddress = ipAddress;
      this.dialog.id = id;
      this.dialog.port = port;
      this.dialog.editflag = false;
      this.dialog.show = true;
    },
     editsure() {
      if (this.dialog.ipAddress === '') {
        this.$messageError('请输入网关IP地址！');
        return;
      }
      else if (this.dialog.port === '') {
        this.$messageError('请输入端口！');
      }
      this.$api.clientinfo
        .updateClientInfo({
          id: this.dialog.id,
          ipAddress: this.dialog.ipAddress,
          port:this.dialog.port
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('编辑成功！');
            this.getlist();
            this.dialog.show = false;
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 当每页条数变化时
    handleSizeChange(data) {
      this.pageSize = data;
      this.pageIndex = 1;
      this.getlist();
    },
    // 当前的页码变化时
    handleCurrentChange(data) {
      this.pageIndex = data;
      this.getlist();
    },
    // 删除网关
    deleteTeam(id) {
      this.$api.clientinfo
        .delClientInfo({
          clientId: id
        })
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('删除成功！');
            if (this.tableData.length === 1) {
              this.pageIndex = this.pageIndex === 1 ? 1 : this.pageIndex - 1;
            }
            this.getlist();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 删除选中行
    handleClose(id) {
      this.$confirm('删除后数据将无法恢复，是否确定?')
        .then(() => {
          this.deleteTeam(id);
        })
        .catch(() => {});
    },
     // 启动定时刷新
    startRefreshTimer() {
      this.refreshTimer = setInterval(() => {
        this.getlist();
      }, 5000); // 每5秒刷新一次
    },
    // 停止定时刷新
    stopRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    }
  },
  created() {
    this.getlist();
    this.startRefreshTimer();
  },
  beforeDestroy() {
    this.stopRefreshTimer(); // 组件销毁前清除定时器，防止内存泄漏
  }
};
</script>
<style lang="scss" scoped>
.opeartbox {
  padding: 15px 20px 5px;
  background: #fff;
  ul {
    li {
      float: left;
      margin-right: 15px;
      margin-bottom: 10px;
      .tit {
        font-size: 14px;
        color: #fff;
        margin-right: 5px;
      }
      .txtbox {
        display: inline-block;
      }
    }
  }
}
.tc pdt10 pdb10 {
  text-align: center;
}
</style>
